import React, { useState, useEffect } from 'react';
export function UrgencyBar() {
  const [message, setMessage] = useState('');
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercent = scrollTop / docHeight;
      if (scrollPercent < 0.2) {
        setMessage('Respira… este puede ser tu momento con Dios');
      } else if (scrollPercent < 0.6) {
        setMessage('Miles de personas ya están encontrando paz cada día');
      } else {
        setMessage('Tómate 2 minutos… y vuelve a conectar');
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      {/* Animación integrada */}
      <style data-id="element-229">
        {`
          @keyframes calmPulse {
            0%, 100% { transform: scale(1); opacity: 0.9; }
            50% { transform: scale(1.04); opacity: 1; }
          }

          .calm-animate {
            animation: calmPulse 4s ease-in-out infinite;
          }
        `}
      </style>

      <div className="fixed top-0 left-0 right-0 z-50 flex justify-center pointer-events-none" data-id="element-230">
        
        <div className="mt-4 px-6 py-3 rounded-full backdrop-blur-md bg-white/70 shadow-lg border border-white/40 calm-animate transition-all duration-700" data-id="element-231">
          
          <p className="text-sm md:text-base text-gray-700 font-medium text-center tracking-wide" data-id="element-232">
            {message}
          </p>

        </div>
      </div>
    </>;
}